<template>
  <div id="deleteConfirmModal">
    <b-modal
      id="delete-modal"
      title="واداروم"
      button-size="sm"
      @hidden="hideModal"
      :hide-footer="footer"
      ref="delete-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="text f_c_c w-100 mb-5 mt-4">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "DelConfirmModal",
  data() {
    return {
      footer: true,
    };
  },
  props: {
    message: String,
  },
  computed: {
    ...mapState({
      ltrRtl: (state) => state.login.ltrRtl,
    }),
  },
  methods: {
    hideModal() {
      EventBus.$emit("copyright", true);
    },
  },
  mounted() {
    this.$refs["delete-modal"].show();
  },
};
</script>

<style lang="scss" scoped>
</style>